

import Zayaan_Humdani from "../../assets/Orators/Zayaan_Humdani.jpg";
import Yasser from "../../assets/Orators/Yasser.jpg";
import steven_j from "../../assets/Orators/steven_j.jpg";
import Rida_Arain from "../../assets/Orators/Rida_Arain.jpg";
import Lela_Tsitaishvili from "../../assets/Orators/Lela_Tsitaishvili.jpg";
import Hao_Wu from "../../assets/Orators/Hao_Wu.jpg";
import dr_louie from "../../assets/Orators/dr_louie.jpg";
import dr_geralad from "../../assets/Orators/dr_geralad.jpg";
import David_Gillam from "../../assets/Orators/David_Gillam.jpg";
import camila from "../../assets/Orators/camila.jpg";
import Alexsandr_Budovsky from "../../assets/Orators/Alexsandr_Budovsky.jpg";

import Zayaan_Humdani_banner from "../../assets/Orator Banners/Zayaan_Humdani_banner.jpg";
import Yasser_banner from "../../assets/Orator Banners/Yasser_banner.jpg";
import steven_j_banner from "../../assets/Orator Banners/steven_j_banner.jpg";
import Rida_Arain_banner from "../../assets/Orator Banners/Rida_Arain_banner.jpg";
import Lela_Tsitaishvili_banner from "../../assets/Orator Banners/Lela_Tsitaishvili_banner.jpg";
import Hao_Wu_banner from "../../assets/Orator Banners/Hao_Wu_banner.jpg";
import dr_louie_banner from "../../assets/Orator Banners/dr_louie_banner.jpg";
import dr_geralad_banner from "../../assets/Orator Banners/dr_geralad_banner.jpg";
import David_Gillam_banner from "../../assets/Orator Banners/David_Gillam_banner.jpg";
import camila_banner from "../../assets/Orator Banners/camila_banner.jpg";
import Alexsandr_Budovsky_banner from "../../assets/Orator Banners/Alexsandr_Budovsky_banner.jpg";

export const orators_about = [
  {
    id: "zayaan-humdani",
    image: Zayaan_Humdani,
    banner: Zayaan_Humdani_banner,
    name: "Dr. Zayaan Humdani",
    from: "United Kingdom",
    about: "Dental Trainee",
    link: "/idom-summit-orators/zayaan-humdani",
  },
  {
    id: "yasser-khaled",
    image: Yasser,
    banner: Yasser_banner,
    name: "Dr. Yasser Khaled",
    from: "USA",
    about: "Assistant Professor",
    link: "/idom-summit-orators/yasser-khaled",
  },
  {
    id: "steven-j-traub",
    image: steven_j,
    banner: steven_j_banner,
    name: "Dr. Steven J. Traub",
    from: "USA",
    about: "Clinical Professor",
    link: "/idom-summit-orators/steven-j-traub",
  },
  {
    id: "rida-arain",
    image: Rida_Arain,
    banner: Rida_Arain_banner,
    name: "Rida Arain",
    from: "United Kingdom",
    about: "Dental Student",
    link: "/idom-summit-orators/rida-arain",
  },
  {
    id: "lela-tsitaishvili",
    image: Lela_Tsitaishvili,
    banner: Lela_Tsitaishvili_banner,
    name: "Prof. Lela Tsitaishvili",
    from: "Georgia",
    about: "Professor",
    link: "/idom-summit-orators/lela-tsitaishvili",
  },
  {
    id: "hao-wu",
    image: Hao_Wu,
    banner: Hao_Wu_banner,
    name: "Dr. Hao Wu",
    from: "China",
    about: "Researcher",
    link: "/idom-summit-orators/hao-wu",
  },
  {
    id: "gregory-louie",
    image: dr_louie,
    banner: dr_louie_banner,
    name: "Dr. Gregory Louie",
    from: "USA",
    about: "Prosthodontist",
    link: "/idom-summit-orators/gregory-louie",
  },
  {
    id: "gerald-green",
    image: dr_geralad,
    banner: dr_geralad_banner,
    name: "Dr. Gerald Green",
    from: "USA",
    about: "Periodontist",
    link: "/idom-summit-orators/gerald-green",
  },
  {
    id: "david-gillam",
    image: David_Gillam,
    banner: David_Gillam_banner,
    name: "Prof. David Gillam",
    from: "United Kingdom",
    about: "Professor",
    link: "/idom-summit-orators/david-gillam",
  },
  {
    id: "camila-paiva-perin",
    image: camila,
    banner: camila_banner,
    name: "Dr. Camila Paiva Perin",
    from: "Brazil",
    about: "Professor",
    link: "/idom-summit-orators/camila-paiva-perin",
  },
  {
    id: "alexsandr-budovsky",
    image: Alexsandr_Budovsky,
    banner: Alexsandr_Budovsky_banner,
    name: "Dr. Alexsandr Budovsky",
    from: "United Arab Emirates",
    about: "Orthopedic Dentist",
    link: "/idom-summit-orators/alexsandr-budovsky",
  },
];


export const Zayaan_Humdani_data = {
  id: "zayaan-humdani",
  image: Zayaan_Humdani,
  banner: Zayaan_Humdani_banner,
  name: "Dr. Zayaan Humdani",
  from: "United Kingdom",
  about:
    "Dr. Zayaan Humdani studied dentistry at Barts and The London, graduating in 2023. He completed his foundation training in Nottingham, England and currently works as a dental core trainee at the Eastman Dental Hospital within the oral surgery department. His post also contains experience within the maxillofacial department at University College London Hospital. He is currently pursuing quality improvement projects to further develop professionally and has delivered an online webinar aimed at helping new graduates adapt to life as a foundation dentist in the United Kingdom.",
};

export const Yasser_data = {
  id: "yasser",
  image: Yasser,
  banner: Yasser_banner,
  name: "Dr. Yasser Khaled",
  from: "USA",
  about:
    "Dr. Yasser Khaled is a son of a diplomat who has visited, worked and studied in 15 different countries across five continents. He holds a BDS from Ain Shams University, Egypt; an MDSc in Oral Pathology from the same university; a fellowship in Oral Surgery from University Sains Malaysia; a MMSc in TMD/Orofacial Pain from the University of Alberta, Canada; and a GPR certificate plus Oral Medicine Certificate from Carolinas Medical Center, USA. He has received hundreds of certificates from around the world, and won the Lester Burkett Award from the American Academy of Oral Medicine for best research in 2017. He currently serves as Assistant Professor at Marquette University School of Dentistry, specializing in Oral Pathology, Oral Medicine and TMD/Orofacial Pain.",
};

export const steven_j_data = {
  id: "steven-j",
  image: steven_j,
  banner: steven_j_banner,
  name: "Dr. Steven J. Traub",
  from: "United States",
  about:
    "Dr. Traub graduated from Creighton University School of Dentistry in 1978, then completed a 3‑year Oral & Maxillofacial Surgery residency at Cook County Hospital in Chicago. He enjoyed a full-time solo practice in Albuquerque, New Mexico until summer 2023. He has since accepted a teaching position at Creighton University Dental School as a Clinical Professor in the Oral & Maxillofacial Surgery department. He also serves on the Board of Directors of the American Institute of Oral Biology (AIOB), continues part-time surgery in Albuquerque, and is pursuing certification with the International Academy of Independent Medical Legal Evaluators—being the first in his field to do so. He has placed dental implants since 1982 and still performs major facial traumatic reconstructive surgery.",
};

export const Rida_Arain_data = {
  id: "rida-arain",
  image: Rida_Arain,
  banner: Rida_Arain_banner,
  name: "Rida Arain",
  from: "United Kingdom",
  about:
    "Rida Arain is a final-year dental student at the University of Manchester with a strong interest in academic dentistry and clinical research. In her final year, she was awarded first place in a regional poster presentation competition, reflecting her commitment to evidence-based practice and academic development. She is due to begin her Dental Foundation Training/Dental Core Training in Birmingham, where she will rotate through Oral Surgery, Oral & Maxillofacial Surgery, and Special Care Dentistry. She hopes to develop a career that brings together her passion for surgery and patient care with a sustained role in research and academia.",
};

export const Lela_Tsitaishvili_data = {
  id: "lela-tsitaishvili",
  image: Lela_Tsitaishvili,
  banner: Lela_Tsitaishvili_banner,
  name: "Prof. Lela Tsitaishvili",
  from: "Georgia",
  about:
    "Prof. Lela Tsitaishvili studied Dentistry at Tbilisi State Medical University (TSMU), Georgia, graduating as a General Practitioner Dentist in 1999. She then pursued a PhD at Tbilisi State University (TSU), receiving her degree in 2015. That same year she joined Caucasus International University as an Associate Professor. Since 2023, she has served as Professor, Head of the Dental Educational Program, and Clinical Director of the University Clinic. She has published approximately 15 articles in scientific journals.",
};

export const Hao_Wu_data = {
  id: "hao-wu",
  image: Hao_Wu,
  banner: Hao_Wu_banner,
  name: "Dr. Hao Wu",
  from: "China",
  about:
    "Dr. Hao Wu is an M.D. Candidate in Stomatology at Xi'an Jiaotong University, focusing on selenoprotein-regulated osteogenic differentiation mechanisms and 3D facial modeling and analysis. He has published multiple SCI-indexed papers and holds two authorized invention patents in biomedical applications. His expertise spans molecular biology, bone regeneration pathways, and computational modeling for craniofacial reconstruction.",
};

export const dr_louie_data = {
  id: "dr-louie",
  image: dr_louie,
  banner: dr_louie_banner,
  name: "Dr. Gregory Louie",
  from: "United States",
  about:
    "Dr. Louie started his dental career as a dental technician before earning his dental degree from the University of the Pacific in 1986. After practicing as a General Dentist, he completed advanced training in dental implants at Brookdale Hospital and Prosthodontics at the University of Illinois at Chicago. He founded the Tri Valley Implant Study Group in 2013 and holds memberships in multiple organizations including ADA, CDA, ACP, AACD, AAID, ICOI, and AO.",
};

export const dr_geralad_data = {
  id: "dr-geralad",
  image: dr_geralad,
  banner: dr_geralad_banner,
  name: "Dr. Gerald C. Green",
  from: "United States",
  about:
    "Dr. Green maintains a full-time periodontal practice in Lancaster, Pennsylvania. He has been a periodontal preceptor for the Lancaster General Hospital GPR since 2012, is a member of numerous dental organizations, and leads a Spear study club. In addition to mucogingival surgery, he performs bone regeneration, dental implant placements, and is a certified LANAP practitioner. In his spare time he enjoys playing golf and traveling with his wife, Aurora.",
};

export const David_Gillam_data = {
  id: "david-gillam",
  image: David_Gillam,
  banner: David_Gillam_banner,
  name: "Prof. David Geoffrey Gillam",
  from: "United Kingdom",
  about:
    "David Geoffrey Gillam graduated from Edinburgh Dental School in 1977 and has been involved in dentistry for over 45 years. His experience spans general practice, community dentistry, university positions, and industry roles. He was on the GDC Specialists’ register in Periodontology (1998–2023) and served as Clinical Reader (Associate Professor) in Translational Dentistry at Barts and The London School of Medicine and Dentistry, QMUL (2009–2022). He now holds a part-time Professorship at QMUL and has authored over 100 scientific papers and several book chapters. His primary research interests include dentine hypersensitivity and dental material development.",
};

export const camila_data = {
  id: "camila",
  image: camila,
  banner: camila_banner,
  name: "Prof. Dr. Camila Paiva Perin",
  from: "Brazil",
  about:
    "Prof. Dr. Camila Paiva Perin is a dentist graduated from the Federal University of Paraná, Brazil, with Specialist, Master and Ph.D. degrees in Endodontics, and specialization in Public Health. She is a tutor in Endodontics, Collective Health, and Dental Clinic at University Tuiuti do Paraná, and coordinates their Endodontics Specialization Course. She also works in the Brazilian public health system (SUS) in Curitiba and specializes in dental trauma, regenerative Endodontic techniques, and paraendodontic surgery.",
};

export const Alexsandr_Budovsky_data = {
  id: "alexsandr-budovsky",
  image: Alexsandr_Budovsky,
  banner: Alexsandr_Budovsky_banner,
  name: "Dr. Alexsandr Budovsky",
  from: "United Arab Emirates",
  about:
    "Dr. Alexsandr Budovsky is an orthopedic dentist with over 26 years of experience in prosthetics, including digital, 3D technologies, veneers, all‑on‑4/6 implant prosthetics, TMJ disorders, pain syndromes, and muscle dysfunction. He has operated his own clinic in Saint Petersburg since 1998 and has authored more than 30 educational courses and online programs on dentistry, TMJ treatment, gnathology, cap splint therapy, and prosthetics. He trained in Munich and Vienna and graduated from The 8th Leningrad Medical School, Pavlov University, and Saint Petersburg State University (Law).",
};


export const orators_details_map = {
  "zayaan-humdani": Zayaan_Humdani_data,
  "yasser-khaled": Yasser_data,
  "steven-j-traub": steven_j_data,
  "rida-arain": Rida_Arain_data,
  "lela-tsitaishvili": Lela_Tsitaishvili_data,
  "hao-wu": Hao_Wu_data,
  "gregory-louie": dr_louie_data,
  "gerald-green": dr_geralad_data,
  "david-gillam": David_Gillam_data,
  "camila-paiva-perin": camila_data,
  "alexsandr-budovsky": Alexsandr_Budovsky_data,
};

export { orators_about as orators };
